const theme = {
  text: '#fff',
  terminalText: '#33ff00',
  highlight: '#33ff00',
  background: '#101215',
  surface: '#000',
  error: '#D32F2F',
  success: '#43A047',
  font: 'Lucida Console, monospace',
  fontSize: '1rem',
  lineHeight: '1.5',
};

export default theme;
